import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { DEFAULT_LANGUAGE } from "@/config/constants";
import { detectBrowserLanguage } from "@/hooks/useBrowserLanguage";

// Custom initializer that detects browser language if no stored preference exists
const getInitialLanguage = () => {
  if (typeof window === "undefined") return DEFAULT_LANGUAGE;

  // Check if we already have a stored preference
  const stored = localStorage.getItem("app-language-preference");
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch {
      // If parsing fails, fall through to browser detection
    }
  }

  // No stored preference, detect browser language using shared utility
  const browserLanguage = detectBrowserLanguage();

  // Store the detected language for future use
  try {
    localStorage.setItem("app-language-preference", JSON.stringify(browserLanguage));
  } catch {
    // localStorage might not be available, ignore error
  }

  return browserLanguage;
};

// Create a persistent atom that stores the language in localStorage
// During SSR, this will use DEFAULT_LANGUAGE to avoid hydration mismatches
// On the client, atomWithStorage will automatically handle localStorage synchronization
export const languageAtom = atomWithStorage<string>("app-language-preference", DEFAULT_LANGUAGE);

// Helper atom to check if language is default
export const isDefaultLanguageAtom = atom((get) => get(languageAtom) === DEFAULT_LANGUAGE);
